module.exports = __webpack_public_path__ + "img/searchnoresults.40050517.png";